import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css"; // Font Awesome
import "./AdminLogin.css";

// Replace with your deployed Google Apps Script URL
const SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycbzCQxTgZHPta6ynrY8pl8ZOmNwftlPegt7Sqvt6Gt_ugwgIff9I1UJOZasO9CQvXUeD/exec";

function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      // Use GET request with query params to avoid CORS
      const url = `${SCRIPT_URL}?type=login&email=${encodeURIComponent(
        email.trim()
      )}&password=${encodeURIComponent(password.trim())}`;

      console.log("Login request URL:", url);

      const response = await fetch(url);
      const data = await response.json();

      console.log("Login response:", data);

      if (data.result === "success") {
        localStorage.setItem("adminLoggedIn", "true");
        navigate("/admin-dashboard", { replace: true });
      } else if (data.result === "invalid") {
        setError("Invalid Admin or Wrong Credentials");
      } else {
        setError("Something went wrong. Try again.");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("Something went wrong. Try again.");
    }

    setLoading(false);
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-card">
        <h2>Admin Login</h2>

        <form onSubmit={handleLogin}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="username"
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />

          {error && <p className="error">{error}</p>}

          <button type="submit" disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminLogin;